import React from 'react';
export function RelatedToEnvironmentalDivider() {
  return <div className="relative w-full overflow-hidden" style={{
    backgroundColor: '#f5f1ed'
  }} data-id="element-427">
      

      <style data-id="element-428">{`
        @keyframes relatedToEnvWave {
          0%, 100% {
            transform: translateX(0) scaleY(1);
          }
          50% {
            transform: translateX(-20px) scaleY(1.03);
          }
        }
        
        @media (prefers-reduced-motion: reduce) {
          svg path {
            animation: none !important;
          }
        }
      `}</style>
    </div>;
}